import * as React from 'react';
export const shoppingBagSvg = React.forwardRef(function shoppingBagSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5 3v-.167c0-.373.17-1.046.596-1.637C6.055.562 6.83 0 8 0s1.945.562 2.403 1.196c.428.59.597 1.264.597 1.637V3h1.21a2 2 0 0 1 1.988 1.78L15 12v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2l.802-7.22A2 2 0 0 1 3.79 3H5Zm1.5 0v-.167c0-.005.009-.104.062-.265.051-.155.133-.331.25-.493.22-.304.57-.575 1.188-.575.619 0 .968.271 1.188.575.117.162.199.338.25.493.053.161.062.26.062.265V3h-3ZM5 4.5v1.75a.75.75 0 0 0 1.5 0V4.5h3v1.75a.75.75 0 0 0 1.5 0V4.5h1.21a.5.5 0 0 1 .497.445l.793 7.138V14a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1.917l.793-7.138A.5.5 0 0 1 3.79 4.5H5Z',
    }),
  );
});
shoppingBagSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var shoppingBag = {
  category: 'icon',
  colorable: true,
  name: 'shoppingBag',
  svg: shoppingBagSvg,
};
